const config = {
  API_BASE_URL: process.env.NEXT_PUBLIC_API_BASE || 'http://127.0.0.1:8080',
  BASE_URL: process.env.NEXT_PUBLIC_BASE_URL || 'http://127.0.0.1:3000',
  APP_BASE_URL: process.env.NEXT_PUBLIC_APP_BASE_URL || 'http://127.0.0.1:3001',
  DEFAULT_LOCALE: process.env.NEXT_PUBLIC_DEFAULT_LOCALE || 'en-US',
  DEFAULT_TIMEZONE: process.env.NEXT_PUBLIC_DEFAULT_TIMEZONE || 'Europe/Istanbul',

  // Upload Configuration
  UPLOAD_TIMEOUT: parseInt(process.env.NEXT_PUBLIC_UPLOAD_TIMEOUT || '1800000', 10), // 30 minutes in milliseconds
  UPLOAD_MAX_DURATION: parseInt(process.env.UPLOAD_MAX_DURATION || '900', 10), // 15 minutes in seconds (Next.js max)
  UPLOAD_MAX_SIZE: parseInt(process.env.NEXT_PUBLIC_UPLOAD_MAX_SIZE || '1073741824', 10) // 1GB in bytes
}

export default config
